import { Request } from "./HttpService";

export const TechByTechRoleService = {
  getAll(id) {
    return Request(`vitae/TechByTechRole/${id}`, "GET").then((data) => {
      return data;
    });
  },
  createOrUpdate(techRoleId, technologies) {
    return Request(
      `vitae/TechByTechRole/${techRoleId}`,
      "POST",
      technologies
    ).then((data) => {
      return data;
    });
  }
};
